"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eDiv = void 0;
const e_estimate_1 = require("./e-estimate");
const expansion_product_1 = require("./expansion-product");
const e_diff_1 = require("./e-diff");
const e_to_bitlength_1 = require("./e-to-bitlength");
const bit_length_1 = require("../double-representation/bit-length");
// We *have* to do the below❗ The assignee is a getter❗ The assigned is a pure function❗
const mult = expansion_product_1.expansionProduct;
const toBitlength = e_to_bitlength_1.eToBitlength;
const bitLength = bit_length_1.expBitLength;
const diff = e_diff_1.eDiff;
const estimate = e_estimate_1.eEstimate;
/**
 * Returns the result of a/b using Goldschmidt division.
 *
 * The result will only be exact if b|a, i.e. if b divides a exactly, else the
 * result will be rounded to the longest bitlength between a and b.
 * @param a the numerator
 * @param b the denominator
 * @param expansionLength the bitlength/53 of the final result, e.g. 1 means
 * standard double precision, 2 means quad, etc up to a max of about 20 at
 * which point underflow cease precision improvement. If the division is known
 * to be exact beforehand (such as in the pseudo remainder sequence algorithm)
 * then set expansionLength === 0 and an exact division will be done.
 */
// TODO - test this function properly or replace with a better one
function eDiv(N, D, expansionLength) {
    let D_ = D;
    let N_ = N;
    let exact = false;
    let resultBitlengthUpperBound = 0;
    if (!expansionLength) {
        let bitlengthN = bitLength(N_);
        let bitlengthD = bitLength(D_);
        resultBitlengthUpperBound = bitlengthN - bitlengthD + 1;
        expansionLength = (resultBitlengthUpperBound / 53) + 1;
        exact = true;
    }
    let F = [1 / estimate(D_)]; // Initial guess - out by 1/2 upls
    let i = 1;
    while (true) {
        N_ = mult(N_, F);
        // The precision bitlength doubles on each iteration
        if (i > expansionLength) {
            // we now have roughly double the needed precision - we actually 
            // only require about the precision and then round properly - this
            // could be implemented in the future.
            if (exact) {
                // We must throw away bits known to be zero. 
                // Any bits > expansionLength * 53 must be thrown away as they
                // are wrong - all other bits are exact.
                N_ = toBitlength(N_, resultBitlengthUpperBound);
                // TODO - below is just for testing - remove later
                //if (compare(mult(D, N_), N) !== 0) {
                //    console.log(mult(D, N_))
                //    throw new Error(`division in-exact - probably due to underflow, N: ${N}, D: ${D}, Result: ${N_}, product: ${mult(D, N_)}`); 
                //} 
                return N_;
            }
            // Returning only significant bits helps with sign determination later on.
            return N_.slice(N_.length - expansionLength, N_.length);
        }
        D_ = mult(D_, F);
        F = diff([2], D_);
        i *= 2;
    }
}
exports.eDiv = eDiv;
//# sourceMappingURL=e-div.js.map